/**
 * Hide SparkLayer sections based on role
 * This script hides various sections for customers based on their role
 * 
 * RELIABILITY FEATURES:
 * - Continuous monitoring every 2 seconds
 * - Enhanced MutationObserver watching for all DOM changes
 * - Multiple retry attempts (up to 20) with optimized delays
 * - Shadow DOM monitoring
 * - Event listeners for clicks, focus, navigation, visibility changes
 * - CSS injection for persistent hiding
 * - Verification checks to ensure elements stay hidden
 * - requestAnimationFrame for optimal timing
 * 
 * Role detection works by checking:
 * - window.customerRole (set from Shopify customer.metafields.custom.role)
 * 
 * Employees (role == 'Employee' or 'employee') will have:
 * - "Mes analyses de données" section hidden completely
 * - Address action buttons ("Ajouter", "Modifier", "Supprimer") hidden in "Mon carnet d'adresse"
 * - "Ajouter une nouvelle adresse" button hidden in "Adresse de livraison" section
 * - "Mes dernières commandes" section hidden completely
 * 
 * Admins (role == 'Admin' or 'admin') will have:
 * - "Ajouter une nouvelle adresse" button hidden in "Mon carnet d'adresse" section
 * - "Ajouter une nouvelle adresse" button hidden in "Adresse de livraison" section
 * 
 * For ALL users (regardless of role):
 * - "Financières" div within "Mes coordonnées" section hidden
 */
(function() {
  'use strict';

  // Utility function to hide an element with multiple methods for maximum reliability
  function hideElementReliably(element) {
    if (!element || typeof element.style === 'undefined') {
      return false;
    }
    
    try {
      // Multiple hiding methods
      element.style.setProperty('display', 'none', 'important');
      element.style.setProperty('visibility', 'hidden', 'important');
      element.style.setProperty('opacity', '0', 'important');
      element.style.setProperty('height', '0', 'important');
      element.style.setProperty('overflow', 'hidden', 'important');
      element.style.setProperty('margin', '0', 'important');
      element.style.setProperty('padding', '0', 'important');
      element.setAttribute('hidden', 'true');
      element.setAttribute('aria-hidden', 'true');
      
      // Add a class for CSS targeting
      element.classList.add('force-hidden-by-script');
      
      return true;
    } catch (e) {
      return false;
    }
  }

  // Utility function to verify element is hidden
  function isElementHidden(element) {
    if (!element) return true;
    
    try {
      var style = window.getComputedStyle(element);
      return style.display === 'none' || 
             style.visibility === 'hidden' || 
             element.hasAttribute('hidden') ||
             element.classList.contains('force-hidden-by-script');
    } catch (e) {
      return false;
    }
  }

  // Inject CSS rules to ensure elements stay hidden
  function injectHidingCSS() {
    var styleId = 'hide-employee-orders-css';
    if (document.getElementById(styleId)) {
      return; // Already injected
    }
    
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = 
      '.force-hidden-by-script { ' +
        'display: none !important; ' +
        'visibility: hidden !important; ' +
        'opacity: 0 !important; ' +
        'height: 0 !important; ' +
        'overflow: hidden !important; ' +
        'margin: 0 !important; ' +
        'padding: 0 !important; ' +
      '}';
    document.head.appendChild(style);
  }

  // Inject CSS immediately
  injectHidingCSS();

  // Function to hide "Ajouter une nouvelle adresse" button for Admins
  function hideAddAddressButtonForAdmins() {
    // Check Shopify customer role metafield
    var customerRole = window.customerRole || '';
    var lowerRole = String(customerRole).toLowerCase();
    var isAdmin = lowerRole === 'admin';

    if (!isAdmin) {
      return;
    }

    // Try to find in regular DOM first
    var allSections = document.querySelectorAll('section');
    for (var k = 0; k < allSections.length; k++) {
      var section = allSections[k];
      var text = section.textContent || '';
      // Check for "Mon carnet d'adresse" section
      if (text.indexOf('Mon carnet d\'adresse') !== -1) {
        // Hide "Ajouter une nouvelle adresse" button in header
        var headerEl = section.querySelector('header');
        if (headerEl) {
          // Look for the div containing the button
          var headerDivs = headerEl.querySelectorAll('div');
          for (var ha = 0; ha < headerDivs.length; ha++) {
            var hDiv = headerDivs[ha];
            var hText = hDiv.textContent || '';
            if (hText.indexOf('Ajouter une nouvelle adresse') !== -1) {
              hDiv.style.display = 'none';
              hDiv.style.visibility = 'hidden';
              hDiv.style.opacity = '0';
              hDiv.style.height = '0';
              hDiv.style.overflow = 'hidden';
              hDiv.setAttribute('hidden', 'true');
              break;
            }
          }
          // Also try to find the button directly
          var addButton = headerEl.querySelector('button');
          if (addButton) {
            var buttonText = addButton.textContent || '';
            if (buttonText.indexOf('Ajouter une nouvelle adresse') !== -1) {
              var buttonParent = addButton.closest('div');
              if (buttonParent) {
                buttonParent.style.display = 'none';
                buttonParent.style.visibility = 'hidden';
                buttonParent.style.opacity = '0';
                buttonParent.style.height = '0';
                buttonParent.style.overflow = 'hidden';
                buttonParent.setAttribute('hidden', 'true');
              }
            }
          }
        }
      }
      // Check for "Adresse de livraison" section (can be in div or section)
      if (text.indexOf('Adresse de livraison') !== -1) {
        // Hide "Ajouter une nouvelle adresse" button in header
        var headerEl = section.querySelector('header');
        if (headerEl) {
          // Look for the div containing the button
          var headerDivs = headerEl.querySelectorAll('div');
          for (var ha = 0; ha < headerDivs.length; ha++) {
            var hDiv = headerDivs[ha];
            var hText = hDiv.textContent || '';
            if (hText.indexOf('Ajouter une nouvelle adresse') !== -1) {
              hDiv.style.display = 'none';
              hDiv.style.visibility = 'hidden';
              hDiv.style.opacity = '0';
              hDiv.style.height = '0';
              hDiv.style.overflow = 'hidden';
              hDiv.setAttribute('hidden', 'true');
              break;
            }
          }
          // Also try to find the button directly
          var addButton = headerEl.querySelector('button');
          if (addButton) {
            var buttonText = addButton.textContent || '';
            if (buttonText.indexOf('Ajouter une nouvelle adresse') !== -1) {
              var buttonParent = addButton.closest('div');
              if (buttonParent) {
                buttonParent.style.display = 'none';
                buttonParent.style.visibility = 'hidden';
                buttonParent.style.opacity = '0';
                buttonParent.style.height = '0';
                buttonParent.style.overflow = 'hidden';
                buttonParent.setAttribute('hidden', 'true');
              }
            }
          }
        }
      }
    }

    // Also check divs (not just sections) for "Adresse de livraison"
    var allDivs = document.querySelectorAll('div');
    for (var d = 0; d < allDivs.length; d++) {
      var div = allDivs[d];
      var divText = div.textContent || '';
      if (divText.indexOf('Adresse de livraison') !== -1) {
        // Look for header within this div
        var headerEl = div.querySelector('header');
        if (!headerEl) {
          // If no header tag, look for h4 directly
          var h4El = div.querySelector('h4');
          if (h4El && h4El.textContent.indexOf('Adresse de livraison') !== -1) {
            // Find the parent container and look for the button div
            var parentContainer = h4El.closest('div');
            if (parentContainer) {
              // Look for the button div (ml-auto class indicates it's the right-aligned button container)
              var buttonDivs = parentContainer.querySelectorAll('div.ml-auto, div[class*="ml-auto"]');
              for (var bd = 0; bd < buttonDivs.length; bd++) {
                var btnDiv = buttonDivs[bd];
                var btnDivText = btnDiv.textContent || '';
                if (btnDivText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                  btnDiv.style.display = 'none';
                  btnDiv.style.visibility = 'hidden';
                  btnDiv.style.opacity = '0';
                  btnDiv.style.height = '0';
                  btnDiv.style.overflow = 'hidden';
                  btnDiv.setAttribute('hidden', 'true');
                  break;
                }
              }
              // Also try to find the button directly
              var addButton = parentContainer.querySelector('button');
              if (addButton) {
                var buttonText = addButton.textContent || '';
                if (buttonText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                  var buttonParent = addButton.closest('div');
                  if (buttonParent) {
                    buttonParent.style.display = 'none';
                    buttonParent.style.visibility = 'hidden';
                    buttonParent.style.opacity = '0';
                    buttonParent.style.height = '0';
                    buttonParent.style.overflow = 'hidden';
                    buttonParent.setAttribute('hidden', 'true');
                  }
                }
              }
            }
          }
        } else {
          // If header exists, use the same logic as sections
          var headerDivs = headerEl.querySelectorAll('div');
          for (var ha = 0; ha < headerDivs.length; ha++) {
            var hDiv = headerDivs[ha];
            var hText = hDiv.textContent || '';
            if (hText.indexOf('Ajouter une nouvelle adresse') !== -1) {
              hDiv.style.display = 'none';
              hDiv.style.visibility = 'hidden';
              hDiv.style.opacity = '0';
              hDiv.style.height = '0';
              hDiv.style.overflow = 'hidden';
              hDiv.setAttribute('hidden', 'true');
              break;
            }
          }
          // Also try to find the button directly
          var addButton = headerEl.querySelector('button');
          if (addButton) {
            var buttonText = addButton.textContent || '';
            if (buttonText.indexOf('Ajouter une nouvelle adresse') !== -1) {
              var buttonParent = addButton.closest('div');
              if (buttonParent) {
                buttonParent.style.display = 'none';
                buttonParent.style.visibility = 'hidden';
                buttonParent.style.opacity = '0';
                buttonParent.style.height = '0';
                buttonParent.style.overflow = 'hidden';
                buttonParent.setAttribute('hidden', 'true');
              }
            }
          }
        }
      }
    }

    // Also try to find in shadow DOM
    var shadowRoot = null;
    
    // Method 1: Find spark-drawer element
    var sparkDrawer = document.querySelector('spark-drawer');
    if (sparkDrawer && sparkDrawer.shadowRoot) {
      shadowRoot = sparkDrawer.shadowRoot;
    }
    
    // Method 2: Try other SparkLayer elements
    if (!shadowRoot) {
      var sparkElements = document.querySelectorAll('[class*="spark"], [id*="spark"]');
      for (var q = 0; q < sparkElements.length; q++) {
        var element = sparkElements[q];
        if (element.shadowRoot) {
          shadowRoot = element.shadowRoot;
          break;
        }
      }
    }

    if (shadowRoot) {
      // Hide "Ajouter une nouvelle adresse" button within "Mon carnet d'adresse" section in shadow DOM
      var addressSection = null;
      var allSectionsForAddressNodeList = shadowRoot.querySelectorAll('section');
      var allSectionsForAddress = [];
      for (var aa = 0; aa < allSectionsForAddressNodeList.length; aa++) {
        allSectionsForAddress.push(allSectionsForAddressNodeList[aa]);
      }
      for (var ab = 0; ab < allSectionsForAddress.length; ab++) {
        var sectionForAddress = allSectionsForAddress[ab];
        var headerForAddress = sectionForAddress.querySelector('h4');
        if (headerForAddress && headerForAddress.textContent.indexOf('Mon carnet d\'adresse') !== -1) {
          addressSection = sectionForAddress;
          break;
        }
      }

      if (addressSection) {
        // Hide "Ajouter une nouvelle adresse" button in header
        var addrHeader = addressSection.querySelector('header');
        if (addrHeader) {
          var addrHeaderDivs = addrHeader.querySelectorAll('div');
          for (var ah = 0; ah < addrHeaderDivs.length; ah++) {
            var ahDiv = addrHeaderDivs[ah];
            var ahText = ahDiv.textContent || '';
            if (ahText.indexOf('Ajouter une nouvelle adresse') !== -1) {
              ahDiv.style.display = 'none';
              ahDiv.style.visibility = 'hidden';
              ahDiv.style.opacity = '0';
              ahDiv.style.height = '0';
              ahDiv.style.overflow = 'hidden';
              ahDiv.setAttribute('hidden', 'true');
              break;
            }
          }
          // Also try to find the button directly
          var shadowAddButton = addrHeader.querySelector('button');
          if (shadowAddButton) {
            var shadowButtonText = shadowAddButton.textContent || '';
            if (shadowButtonText.indexOf('Ajouter une nouvelle adresse') !== -1) {
              var shadowButtonParent = shadowAddButton.closest('div');
              if (shadowButtonParent) {
                shadowButtonParent.style.display = 'none';
                shadowButtonParent.style.visibility = 'hidden';
                shadowButtonParent.style.opacity = '0';
                shadowButtonParent.style.height = '0';
                shadowButtonParent.style.overflow = 'hidden';
                shadowButtonParent.setAttribute('hidden', 'true');
              }
            }
          }
        }
      }

      // Also hide "Ajouter une nouvelle adresse" button within "Adresse de livraison" section in shadow DOM
      var deliverySection = null;
      var allSectionsForDeliveryNodeList = shadowRoot.querySelectorAll('section');
      var allSectionsForDelivery = [];
      for (var ad = 0; ad < allSectionsForDeliveryNodeList.length; ad++) {
        allSectionsForDelivery.push(allSectionsForDeliveryNodeList[ad]);
      }
      for (var ae = 0; ae < allSectionsForDelivery.length; ae++) {
        var sectionForDelivery = allSectionsForDelivery[ae];
        var headerForDelivery = sectionForDelivery.querySelector('h4');
        if (headerForDelivery && headerForDelivery.textContent.indexOf('Adresse de livraison') !== -1) {
          deliverySection = sectionForDelivery;
          break;
        }
      }

      if (deliverySection) {
        // Hide "Ajouter une nouvelle adresse" button in header
        var delHeader = deliverySection.querySelector('header');
        if (delHeader) {
          var delHeaderDivs = delHeader.querySelectorAll('div');
          for (var dh = 0; dh < delHeaderDivs.length; dh++) {
            var dhDiv = delHeaderDivs[dh];
            var dhText = dhDiv.textContent || '';
            if (dhText.indexOf('Ajouter une nouvelle adresse') !== -1) {
              dhDiv.style.display = 'none';
              dhDiv.style.visibility = 'hidden';
              dhDiv.style.opacity = '0';
              dhDiv.style.height = '0';
              dhDiv.style.overflow = 'hidden';
              dhDiv.setAttribute('hidden', 'true');
              break;
            }
          }
          // Also try to find the button directly
          var shadowDelButton = delHeader.querySelector('button');
          if (shadowDelButton) {
            var shadowDelButtonText = shadowDelButton.textContent || '';
            if (shadowDelButtonText.indexOf('Ajouter une nouvelle adresse') !== -1) {
              var shadowDelButtonParent = shadowDelButton.closest('div');
              if (shadowDelButtonParent) {
                shadowDelButtonParent.style.display = 'none';
                shadowDelButtonParent.style.visibility = 'hidden';
                shadowDelButtonParent.style.opacity = '0';
                shadowDelButtonParent.style.height = '0';
                shadowDelButtonParent.style.overflow = 'hidden';
                shadowDelButtonParent.setAttribute('hidden', 'true');
              }
            }
          }
        }
      }

      // Also check divs in shadow DOM for "Adresse de livraison"
      var allShadowDivs = shadowRoot.querySelectorAll('div');
      for (var sd = 0; sd < allShadowDivs.length; sd++) {
        var shadowDiv = allShadowDivs[sd];
        var shadowDivText = shadowDiv.textContent || '';
        if (shadowDivText.indexOf('Adresse de livraison') !== -1) {
          // Look for header within this div
          var shadowHeaderEl = shadowDiv.querySelector('header');
          if (!shadowHeaderEl) {
            // If no header tag, look for h4 directly
            var shadowH4El = shadowDiv.querySelector('h4');
            if (shadowH4El && shadowH4El.textContent.indexOf('Adresse de livraison') !== -1) {
              // Find the parent container and look for the button div
              var shadowParentContainer = shadowH4El.closest('div');
              if (shadowParentContainer) {
                // Look for the button div (ml-auto class indicates it's the right-aligned button container)
                var shadowButtonDivs = shadowParentContainer.querySelectorAll('div.ml-auto, div[class*="ml-auto"]');
                for (var sbd = 0; sbd < shadowButtonDivs.length; sbd++) {
                  var shadowBtnDiv = shadowButtonDivs[sbd];
                  var shadowBtnDivText = shadowBtnDiv.textContent || '';
                  if (shadowBtnDivText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                    shadowBtnDiv.style.display = 'none';
                    shadowBtnDiv.style.visibility = 'hidden';
                    shadowBtnDiv.style.opacity = '0';
                    shadowBtnDiv.style.height = '0';
                    shadowBtnDiv.style.overflow = 'hidden';
                    shadowBtnDiv.setAttribute('hidden', 'true');
                    break;
                  }
                }
                // Also try to find the button directly
                var shadowAddBtn = shadowParentContainer.querySelector('button');
                if (shadowAddBtn) {
                  var shadowAddBtnText = shadowAddBtn.textContent || '';
                  if (shadowAddBtnText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                    var shadowAddBtnParent = shadowAddBtn.closest('div');
                    if (shadowAddBtnParent) {
                      shadowAddBtnParent.style.display = 'none';
                      shadowAddBtnParent.style.visibility = 'hidden';
                      shadowAddBtnParent.style.opacity = '0';
                      shadowAddBtnParent.style.height = '0';
                      shadowAddBtnParent.style.overflow = 'hidden';
                      shadowAddBtnParent.setAttribute('hidden', 'true');
                    }
                  }
                }
              }
            }
          } else {
            // If header exists, use the same logic as sections
            var shadowHeaderDivs = shadowHeaderEl.querySelectorAll('div');
            for (var shd = 0; shd < shadowHeaderDivs.length; shd++) {
              var shadowHDiv = shadowHeaderDivs[shd];
              var shadowHText = shadowHDiv.textContent || '';
              if (shadowHText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                shadowHDiv.style.display = 'none';
                shadowHDiv.style.visibility = 'hidden';
                shadowHDiv.style.opacity = '0';
                shadowHDiv.style.height = '0';
                shadowHDiv.style.overflow = 'hidden';
                shadowHDiv.setAttribute('hidden', 'true');
                break;
              }
            }
            // Also try to find the button directly
            var shadowAddBtn2 = shadowHeaderEl.querySelector('button');
            if (shadowAddBtn2) {
              var shadowBtnText2 = shadowAddBtn2.textContent || '';
              if (shadowBtnText2.indexOf('Ajouter une nouvelle adresse') !== -1) {
                var shadowBtnParent2 = shadowAddBtn2.closest('div');
                if (shadowBtnParent2) {
                  shadowBtnParent2.style.display = 'none';
                  shadowBtnParent2.style.visibility = 'hidden';
                  shadowBtnParent2.style.opacity = '0';
                  shadowBtnParent2.style.height = '0';
                  shadowBtnParent2.style.overflow = 'hidden';
                  shadowBtnParent2.setAttribute('hidden', 'true');
                }
              }
            }
          }
        }
      }
    }
  }

  // Function to hide "Financières" div for everyone (not role-specific)
  function hideFinancieresDiv() {
    // Try to find in regular DOM first
    var allSections = document.querySelectorAll('section');
    for (var k = 0; k < allSections.length; k++) {
      var section = allSections[k];
      var text = section.textContent || '';
      // Check for "Mes coordonnées" section and hide "Financières" div
      if (text.indexOf('Mes coordonnées') !== -1) {
        var contactDivs = section.querySelectorAll('div');
        for (var m = 0; m < contactDivs.length; m++) {
          var div = contactDivs[m];
          var span = div.querySelector('span');
          if (span && span.textContent.indexOf('Financières') !== -1) {
            div.style.display = 'none';
            div.style.visibility = 'hidden';
            div.style.opacity = '0';
            div.style.height = '0';
            div.style.overflow = 'hidden';
            div.setAttribute('hidden', 'true');
            break;
          }
        }
      }
    }

    // Also try to find in shadow DOM
    var shadowRoot = null;
    
    // Method 1: Find spark-drawer element
    var sparkDrawer = document.querySelector('spark-drawer');
    if (sparkDrawer && sparkDrawer.shadowRoot) {
      shadowRoot = sparkDrawer.shadowRoot;
    }
    
    // Method 2: Try other SparkLayer elements
    if (!shadowRoot) {
      var sparkElements = document.querySelectorAll('[class*="spark"], [id*="spark"]');
      for (var q = 0; q < sparkElements.length; q++) {
        var element = sparkElements[q];
        if (element.shadowRoot) {
          shadowRoot = element.shadowRoot;
          break;
        }
      }
    }

    if (shadowRoot) {
      // Hide "Financières" div within "Mes coordonnées" section in shadow DOM
      var contactSection = null;
      var allSectionsForContactNodeList = shadowRoot.querySelectorAll('section');
      var allSectionsForContact = [];
      for (var v = 0; v < allSectionsForContactNodeList.length; v++) {
        allSectionsForContact.push(allSectionsForContactNodeList[v]);
      }
      for (var r = 0; r < allSectionsForContact.length; r++) {
        var sectionForContact = allSectionsForContact[r];
        var headerForContact = sectionForContact.querySelector('h4');
        if (headerForContact && headerForContact.textContent.indexOf('Mes coordonnées') !== -1) {
          contactSection = sectionForContact;
          break;
        }
      }
      
      if (contactSection) {
        var allDivs = contactSection.querySelectorAll('div');
        for (var j = 0; j < allDivs.length; j++) {
          var div = allDivs[j];
          var span = div.querySelector('span');
          if (span && span.textContent.indexOf('Financières') !== -1) {
            div.style.display = 'none';
            div.style.visibility = 'hidden';
            div.style.opacity = '0';
            div.style.height = '0';
            div.style.overflow = 'hidden';
            div.setAttribute('hidden', 'true');
            break;
          }
        }
      }
    }
  }

  function hideDataAnalysisForEmployees() {
      // Check Shopify customer role metafield
      var customerRole = window.customerRole || '';
      var lowerRole = String(customerRole).toLowerCase();
      var isEmployee = lowerRole === 'employee';

      if (!isEmployee) {
        return false;
      }
        
        // Try multiple methods to find the SparkLayer content
        var shadowRoot = null;
        
        // Method 1: Find spark-drawer element
        var sparkDrawer = document.querySelector('spark-drawer');
        if (sparkDrawer && sparkDrawer.shadowRoot) {
          shadowRoot = sparkDrawer.shadowRoot;
         
        }
        
        // Method 2: Try other SparkLayer elements
        if (!shadowRoot) {
          var sparkElements = document.querySelectorAll('[class*="spark"], [id*="spark"]');
          for (var q = 0; q < sparkElements.length; q++) {
            var element = sparkElements[q];
            if (element.shadowRoot) {
              shadowRoot = element.shadowRoot;
          
              break;
            }
          }
        }
        
        // Method 3: Try to find in regular DOM (not in shadow)
        if (!shadowRoot) {
    
          var allSections = document.querySelectorAll('section');
    
          
          var foundDataAnalysis = false;
          for (var k = 0; k < allSections.length; k++) {
            var section = allSections[k];
            var text = section.textContent || '';
            // Check for data analysis section
            if (text.indexOf('Mes analyses de données') !== -1 || 
                text.indexOf('Historique d\'achat') !== -1 ||
                text.indexOf('Rapports') !== -1) {

              section.style.display = 'none';
              section.style.visibility = 'hidden';
              section.style.opacity = '0';
              section.style.height = '0';
              section.style.overflow = 'hidden';
              section.setAttribute('hidden', 'true');
              foundDataAnalysis = true;
            }
            // Check for "Mon carnet d'adresse" section
            if (text.indexOf('Mon carnet d\'adresse') !== -1) {
              // Hide "Ajouter une nouvelle adresse" button in header
              var headerEl = section.querySelector('header');
              if (headerEl) {
                var headerDivs = headerEl.querySelectorAll('div');
                for (var ha = 0; ha < headerDivs.length; ha++) {
                  var hDiv = headerDivs[ha];
                  var hText = hDiv.textContent || '';
                  if (hText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                    hDiv.style.display = 'none';
                    hDiv.style.visibility = 'hidden';
                    hDiv.style.opacity = '0';
                    hDiv.style.height = '0';
                    hDiv.style.overflow = 'hidden';
                    hDiv.setAttribute('hidden', 'true');
         
                    break;
                  }
                }
              }
              // Hide edit/delete buttons for each address
              var editButtons = section.querySelectorAll('button[title=\"Modifier une adresse\"]');
              for (var eb = 0; eb < editButtons.length; eb++) {
                editButtons[eb].style.display = 'none';
                editButtons[eb].style.visibility = 'hidden';
              }
              var deleteButtons = section.querySelectorAll('button[title=\"Supprimer une adresse\"]');
              for (var db = 0; db < deleteButtons.length; db++) {
                deleteButtons[db].style.display = 'none';
                deleteButtons[db].style.visibility = 'hidden';
              }
            }
            // Check for "Adresse de livraison" section
            if (text.indexOf('Adresse de livraison') !== -1) {
              // Hide "Ajouter une nouvelle adresse" button in header
              var headerEl = section.querySelector('header');
              if (headerEl) {
                var headerDivs = headerEl.querySelectorAll('div');
                for (var ha = 0; ha < headerDivs.length; ha++) {
                  var hDiv = headerDivs[ha];
                  var hText = hDiv.textContent || '';
                  if (hText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                    hDiv.style.display = 'none';
                    hDiv.style.visibility = 'hidden';
                    hDiv.style.opacity = '0';
                    hDiv.style.height = '0';
                    hDiv.style.overflow = 'hidden';
                    hDiv.setAttribute('hidden', 'true');
                    break;
                  }
                }
                // Also try to find the button directly
                var addButton = headerEl.querySelector('button');
                if (addButton) {
                  var buttonText = addButton.textContent || '';
                  if (buttonText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                    var buttonParent = addButton.closest('div');
                    if (buttonParent) {
                      buttonParent.style.display = 'none';
                      buttonParent.style.visibility = 'hidden';
                      buttonParent.style.opacity = '0';
                      buttonParent.style.height = '0';
                      buttonParent.style.overflow = 'hidden';
                      buttonParent.setAttribute('hidden', 'true');
                    }
                  }
                }
              }
            }
            // Check for "Mes dernières commandes" section - hide completely for Employees
            if (text.indexOf('Mes dernières commandes') !== -1) {
      
              section.style.display = 'none';
              section.style.visibility = 'hidden';
              section.style.opacity = '0';
              section.style.height = '0';
              section.style.overflow = 'hidden';
              section.setAttribute('hidden', 'true');
            }
          }
          
          // Also check divs (not just sections) for "Adresse de livraison"
          var allDivs = document.querySelectorAll('div');
          for (var d = 0; d < allDivs.length; d++) {
            var div = allDivs[d];
            var divText = div.textContent || '';
            if (divText.indexOf('Adresse de livraison') !== -1) {
              // Look for header within this div
              var headerEl = div.querySelector('header');
              if (!headerEl) {
                // If no header tag, look for h4 directly
                var h4El = div.querySelector('h4');
                if (h4El && h4El.textContent.indexOf('Adresse de livraison') !== -1) {
                  // Find the parent container and look for the button div
                  var parentContainer = h4El.closest('div');
                  if (parentContainer) {
                    // Look for the button div (ml-auto class indicates it's the right-aligned button container)
                    var buttonDivs = parentContainer.querySelectorAll('div.ml-auto, div[class*="ml-auto"]');
                    for (var bd = 0; bd < buttonDivs.length; bd++) {
                      var btnDiv = buttonDivs[bd];
                      var btnDivText = btnDiv.textContent || '';
                      if (btnDivText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                        btnDiv.style.display = 'none';
                        btnDiv.style.visibility = 'hidden';
                        btnDiv.style.opacity = '0';
                        btnDiv.style.height = '0';
                        btnDiv.style.overflow = 'hidden';
                        btnDiv.setAttribute('hidden', 'true');
                        break;
                      }
                    }
                    // Also try to find the button directly
                    var addButton = parentContainer.querySelector('button');
                    if (addButton) {
                      var buttonText = addButton.textContent || '';
                      if (buttonText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                        var buttonParent = addButton.closest('div');
                        if (buttonParent) {
                          buttonParent.style.display = 'none';
                          buttonParent.style.visibility = 'hidden';
                          buttonParent.style.opacity = '0';
                          buttonParent.style.height = '0';
                          buttonParent.style.overflow = 'hidden';
                          buttonParent.setAttribute('hidden', 'true');
                        }
                      }
                    }
                  }
                }
              } else {
                // If header exists, use the same logic as sections
                var headerDivs = headerEl.querySelectorAll('div');
                for (var ha = 0; ha < headerDivs.length; ha++) {
                  var hDiv = headerDivs[ha];
                  var hText = hDiv.textContent || '';
                  if (hText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                    hDiv.style.display = 'none';
                    hDiv.style.visibility = 'hidden';
                    hDiv.style.opacity = '0';
                    hDiv.style.height = '0';
                    hDiv.style.overflow = 'hidden';
                    hDiv.setAttribute('hidden', 'true');
                    break;
                  }
                }
                // Also try to find the button directly
                var addButton = headerEl.querySelector('button');
                if (addButton) {
                  var buttonText = addButton.textContent || '';
                  if (buttonText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                    var buttonParent = addButton.closest('div');
                    if (buttonParent) {
                      buttonParent.style.display = 'none';
                      buttonParent.style.visibility = 'hidden';
                      buttonParent.style.opacity = '0';
                      buttonParent.style.height = '0';
                      buttonParent.style.overflow = 'hidden';
                      buttonParent.setAttribute('hidden', 'true');
                    }
                  }
                }
              }
            }
          }
          
          if (foundDataAnalysis) {
            return true;
          }
        }
        
        if (!shadowRoot) {
         
          return false;
        }

        // Look for "Mes analyses de données" section by multiple methods
        var dataAnalysisSection = null;
        
        // Method 1: Look for sections with h4 containing "Mes analyses de données"
        var sectionsArray = shadowRoot.querySelectorAll('section');
        var sections = [];
        for (var u = 0; u < sectionsArray.length; u++) {
          sections.push(sectionsArray[u]);
        }
        for (var n = 0; n < sections.length; n++) {
          var section = sections[n];
          var header = section.querySelector('h4');
          if (header && header.textContent.indexOf('Mes analyses de données') !== -1) {
            dataAnalysisSection = section;
            break;
          }
        }
        
        // Method 2: Look for sections containing "Historique d'achat" button
        if (!dataAnalysisSection) {
          for (var o = 0; o < sections.length; o++) {
            var section2 = sections[o];
            var text2 = section2.textContent || '';
            if (text2.indexOf('Historique d\'achat') !== -1 || 
                text2.indexOf('Mes analyses de données') !== -1 ||
                (text2.indexOf('analyses') !== -1 && text2.indexOf('données') !== -1)) {
              dataAnalysisSection = section2;
              break;
            }
          }
        }
        
        // Method 3: Look for sections with "Rapports" table header
        if (!dataAnalysisSection) {
          for (var p = 0; p < sections.length; p++) {
            var section3 = sections[p];
            var table = section3.querySelector('table');
            if (table) {
              var th = table.querySelector('th');
              if (th && th.textContent.indexOf('Rapports') !== -1) {
                dataAnalysisSection = section3;
                break;
              }
            }
          }
        }
        
        // Method 4: Look for any element containing the exact text
        if (!dataAnalysisSection) {
          var allElements = shadowRoot.querySelectorAll('*');
          for (var i = 0; i < allElements.length; i++) {
            var element = allElements[i];
            if (element.textContent && 
                (element.textContent.indexOf('Mes analyses de données') !== -1 || 
                 element.textContent.indexOf('Historique d\'achat') !== -1 ||
                 element.textContent.indexOf('Rapports') !== -1)) {
              dataAnalysisSection = element.closest('section');
              if (dataAnalysisSection) {
      
                break;
          }
        }
          }
        }
        
        if (dataAnalysisSection) {
          // Hide using multiple methods for maximum effectiveness
          dataAnalysisSection.style.display = 'none';
          dataAnalysisSection.style.visibility = 'hidden';
          dataAnalysisSection.style.opacity = '0';
          dataAnalysisSection.style.height = '0';
          dataAnalysisSection.style.overflow = 'hidden';
          dataAnalysisSection.setAttribute('hidden', 'true');
      
        }

        // Also hide address actions within "Mon carnet d'adresse" section
        var addressSection = null;
        var allSectionsForAddressNodeList = shadowRoot.querySelectorAll('section');
        var allSectionsForAddress = [];
        for (var aa = 0; aa < allSectionsForAddressNodeList.length; aa++) {
          allSectionsForAddress.push(allSectionsForAddressNodeList[aa]);
        }
        for (var ab = 0; ab < allSectionsForAddress.length; ab++) {
          var sectionForAddress = allSectionsForAddress[ab];
          var headerForAddress = sectionForAddress.querySelector('h4');
          if (headerForAddress && headerForAddress.textContent.indexOf('Mon carnet d\'adresse') !== -1) {
            addressSection = sectionForAddress;
            break;
          }
        }

        if (addressSection) {
          // Hide "Ajouter une nouvelle adresse" button in header
          var addrHeader = addressSection.querySelector('header');
          if (addrHeader) {
            var addrHeaderDivs = addrHeader.querySelectorAll('div');
            for (var ah = 0; ah < addrHeaderDivs.length; ah++) {
              var ahDiv = addrHeaderDivs[ah];
              var ahText = ahDiv.textContent || '';
              if (ahText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                ahDiv.style.display = 'none';
                ahDiv.style.visibility = 'hidden';
                ahDiv.style.opacity = '0';
                ahDiv.style.height = '0';
                ahDiv.style.overflow = 'hidden';
                ahDiv.setAttribute('hidden', 'true');
               
                break;
          }
        }
          }
          // Hide edit/delete buttons for each address
          var sEditButtons = addressSection.querySelectorAll('button[title=\"Modifier une adresse\"]');
          for (var se = 0; se < sEditButtons.length; se++) {
            sEditButtons[se].style.display = 'none';
            sEditButtons[se].style.visibility = 'hidden';
          }
          var sDeleteButtons = addressSection.querySelectorAll('button[title=\"Supprimer une adresse\"]');
          for (var sd = 0; sd < sDeleteButtons.length; sd++) {
            sDeleteButtons[sd].style.display = 'none';
            sDeleteButtons[sd].style.visibility = 'hidden';
          }
        }

        // Also hide "Ajouter une nouvelle adresse" button within "Adresse de livraison" section in shadow DOM
        var deliverySection = null;
        var allSectionsForDeliveryNodeList = shadowRoot.querySelectorAll('section');
        var allSectionsForDelivery = [];
        for (var ad = 0; ad < allSectionsForDeliveryNodeList.length; ad++) {
          allSectionsForDelivery.push(allSectionsForDeliveryNodeList[ad]);
        }
        for (var ae = 0; ae < allSectionsForDelivery.length; ae++) {
          var sectionForDelivery = allSectionsForDelivery[ae];
          var headerForDelivery = sectionForDelivery.querySelector('h4');
          if (headerForDelivery && headerForDelivery.textContent.indexOf('Adresse de livraison') !== -1) {
            deliverySection = sectionForDelivery;
            break;
          }
        }

        if (deliverySection) {
          // Hide "Ajouter une nouvelle adresse" button in header
          var delHeader = deliverySection.querySelector('header');
          if (delHeader) {
            var delHeaderDivs = delHeader.querySelectorAll('div');
            for (var dh = 0; dh < delHeaderDivs.length; dh++) {
              var dhDiv = delHeaderDivs[dh];
              var dhText = dhDiv.textContent || '';
              if (dhText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                dhDiv.style.display = 'none';
                dhDiv.style.visibility = 'hidden';
                dhDiv.style.opacity = '0';
                dhDiv.style.height = '0';
                dhDiv.style.overflow = 'hidden';
                dhDiv.setAttribute('hidden', 'true');
                break;
              }
            }
            // Also try to find the button directly
            var shadowDelButton = delHeader.querySelector('button');
            if (shadowDelButton) {
              var shadowDelButtonText = shadowDelButton.textContent || '';
              if (shadowDelButtonText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                var shadowDelButtonParent = shadowDelButton.closest('div');
                if (shadowDelButtonParent) {
                  shadowDelButtonParent.style.display = 'none';
                  shadowDelButtonParent.style.visibility = 'hidden';
                  shadowDelButtonParent.style.opacity = '0';
                  shadowDelButtonParent.style.height = '0';
                  shadowDelButtonParent.style.overflow = 'hidden';
                  shadowDelButtonParent.setAttribute('hidden', 'true');
                }
              }
            }
          }
        }

        // Also check divs in shadow DOM for "Adresse de livraison"
        var allShadowDivs = shadowRoot.querySelectorAll('div');
        for (var sd = 0; sd < allShadowDivs.length; sd++) {
          var shadowDiv = allShadowDivs[sd];
          var shadowDivText = shadowDiv.textContent || '';
          if (shadowDivText.indexOf('Adresse de livraison') !== -1) {
            // Look for header within this div
            var shadowHeaderEl = shadowDiv.querySelector('header');
            if (!shadowHeaderEl) {
              // If no header tag, look for h4 directly
              var shadowH4El = shadowDiv.querySelector('h4');
              if (shadowH4El && shadowH4El.textContent.indexOf('Adresse de livraison') !== -1) {
                // Find the parent container and look for the button div
                var shadowParentContainer = shadowH4El.closest('div');
                if (shadowParentContainer) {
                  // Look for the button div (ml-auto class indicates it's the right-aligned button container)
                  var shadowButtonDivs = shadowParentContainer.querySelectorAll('div.ml-auto, div[class*="ml-auto"]');
                  for (var sbd = 0; sbd < shadowButtonDivs.length; sbd++) {
                    var shadowBtnDiv = shadowButtonDivs[sbd];
                    var shadowBtnDivText = shadowBtnDiv.textContent || '';
                    if (shadowBtnDivText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                      shadowBtnDiv.style.display = 'none';
                      shadowBtnDiv.style.visibility = 'hidden';
                      shadowBtnDiv.style.opacity = '0';
                      shadowBtnDiv.style.height = '0';
                      shadowBtnDiv.style.overflow = 'hidden';
                      shadowBtnDiv.setAttribute('hidden', 'true');
                      break;
                    }
                  }
                  // Also try to find the button directly
                  var shadowAddBtn = shadowParentContainer.querySelector('button');
                  if (shadowAddBtn) {
                    var shadowAddBtnText = shadowAddBtn.textContent || '';
                    if (shadowAddBtnText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                      var shadowAddBtnParent = shadowAddBtn.closest('div');
                      if (shadowAddBtnParent) {
                        shadowAddBtnParent.style.display = 'none';
                        shadowAddBtnParent.style.visibility = 'hidden';
                        shadowAddBtnParent.style.opacity = '0';
                        shadowAddBtnParent.style.height = '0';
                        shadowAddBtnParent.style.overflow = 'hidden';
                        shadowAddBtnParent.setAttribute('hidden', 'true');
                      }
                    }
                  }
                }
              }
            } else {
              // If header exists, use the same logic as sections
              var shadowHeaderDivs = shadowHeaderEl.querySelectorAll('div');
              for (var shd = 0; shd < shadowHeaderDivs.length; shd++) {
                var shadowHDiv = shadowHeaderDivs[shd];
                var shadowHText = shadowHDiv.textContent || '';
                if (shadowHText.indexOf('Ajouter une nouvelle adresse') !== -1) {
                  shadowHDiv.style.display = 'none';
                  shadowHDiv.style.visibility = 'hidden';
                  shadowHDiv.style.opacity = '0';
                  shadowHDiv.style.height = '0';
                  shadowHDiv.style.overflow = 'hidden';
                  shadowHDiv.setAttribute('hidden', 'true');
                  break;
                }
              }
              // Also try to find the button directly
              var shadowAddBtn2 = shadowHeaderEl.querySelector('button');
              if (shadowAddBtn2) {
                var shadowBtnText2 = shadowAddBtn2.textContent || '';
                if (shadowBtnText2.indexOf('Ajouter une nouvelle adresse') !== -1) {
                  var shadowBtnParent2 = shadowAddBtn2.closest('div');
                  if (shadowBtnParent2) {
                    shadowBtnParent2.style.display = 'none';
                    shadowBtnParent2.style.visibility = 'hidden';
                    shadowBtnParent2.style.opacity = '0';
                    shadowBtnParent2.style.height = '0';
                    shadowBtnParent2.style.overflow = 'hidden';
                    shadowBtnParent2.setAttribute('hidden', 'true');
                  }
                }
              }
            }
          }
        }

        // Also hide "Mes dernières commandes" section completely for Employees
        var ordersSection = null;
        var allSectionsForOrdersNodeList = shadowRoot.querySelectorAll('section');
        var allSectionsForOrders = [];
        for (var ao = 0; ao < allSectionsForOrdersNodeList.length; ao++) {
          allSectionsForOrders.push(allSectionsForOrdersNodeList[ao]);
        }
        for (var ac = 0; ac < allSectionsForOrders.length; ac++) {
          var sectionForOrders = allSectionsForOrders[ac];
          var headerForOrders = sectionForOrders.querySelector('h4');
          if (headerForOrders && headerForOrders.textContent.indexOf('Mes dernières commandes') !== -1) {
            ordersSection = sectionForOrders;
            break;
          }
        }

        if (ordersSection) {
          ordersSection.style.display = 'none';
          ordersSection.style.visibility = 'hidden';
          ordersSection.style.opacity = '0';
          ordersSection.style.height = '0';
          ordersSection.style.overflow = 'hidden';
          ordersSection.setAttribute('hidden', 'true');

          }

        if (dataAnalysisSection) {
        return true;
        } else {
    
      return false;
    }
  }

  // Aggressive retry mechanism with multiple strategies (ES5-compatible)
  function attemptHideSections(attempt, maxAttempts) {
    // Provide default values explicitly for older parsers
    if (typeof attempt === 'undefined') {
      attempt = 1;
    }
    if (typeof maxAttempts === 'undefined') {
      maxAttempts = 20; // Increased from 10 to 20
    }

    // Always hide "Financières" div for everyone (not role-specific)
    hideFinancieresDiv();
    
    // Hide "Ajouter une nouvelle adresse" button for Admins
    hideAddAddressButtonForAdmins();
    
    if (hideDataAnalysisForEmployees()) {
      return;
    }

    if (attempt < maxAttempts) {
      // Use shorter delays for more frequent checks
      var delay = attempt <= 5 ? 100 : (attempt <= 10 ? 200 : Math.min(500 * Math.pow(1.2, attempt - 10), 2000));
      setTimeout(function() {
        attemptHideSections(attempt + 1, maxAttempts);
      }, delay);
    }
  }

  // Continuous monitoring function that runs periodically
  function continuousMonitoring() {
    hideFinancieresDiv();
    hideAddAddressButtonForAdmins();
    hideDataAnalysisForEmployees();
  }

  // Start continuous monitoring every 2 seconds (runs indefinitely)
  var continuousInterval = setInterval(function() {
    continuousMonitoring();
  }, 2000);

  // Start the process when DOM is ready with multiple strategies (ES5-compatible)
  function initializeHiding() {
    // Immediate attempt
    continuousMonitoring();
    attemptHideSections(1, 20);
    
    // Multiple delayed attempts to catch late-loading content
    setTimeout(function() {
      continuousMonitoring();
      attemptHideSections(1, 15);
    }, 500);
    
    setTimeout(function() {
      continuousMonitoring();
      attemptHideSections(1, 10);
    }, 1500);
    
    setTimeout(function() {
      continuousMonitoring();
      attemptHideSections(1, 10);
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(function() {
        initializeHiding();
      }, 100);
    });
  } else {
    // DOM already loaded
    setTimeout(function() {
      initializeHiding();
    }, 100);
  }

  // Also run on window load (after all resources loaded)
  if (typeof window !== 'undefined') {
    window.addEventListener('load', function() {
      setTimeout(function() {
        continuousMonitoring();
        attemptHideSections(1, 15);
      }, 500);
    });
  }

  // Enhanced MutationObserver for dynamic content changes (ES5-compatible)
  var observer = new MutationObserver(function(mutations) {
    var shouldRun = false;
    
    for (var s = 0; s < mutations.length; s++) {
      var mutation = mutations[s];
      
      // Check for any DOM changes
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        shouldRun = true;
        
        // Check if SparkLayer drawer was added
        var addedNodesNodeList = mutation.addedNodes;
        var addedNodes = [];
        for (var w = 0; w < addedNodesNodeList.length; w++) {
          addedNodes.push(addedNodesNodeList[w]);
        }
        for (var t = 0; t < addedNodes.length; t++) {
          var node = addedNodes[t];
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check for SparkLayer elements
            if (node.tagName === 'SPARK-DRAWER' || 
                (node.querySelector && node.querySelector('spark-drawer')) ||
                (node.className && (node.className.indexOf('spark') !== -1 || node.className.indexOf('Spark') !== -1)) ||
                (node.id && (node.id.indexOf('spark') !== -1 || node.id.indexOf('Spark') !== -1))) {
              shouldRun = true;
              break;
            }
            // Check if any added node contains sections we care about
            if (node.textContent) {
              var text = node.textContent;
              if (text.indexOf('Mes coordonnées') !== -1 ||
                  text.indexOf('Mon carnet d\'adresse') !== -1 ||
                  text.indexOf('Adresse de livraison') !== -1 ||
                  text.indexOf('Mes analyses de données') !== -1 ||
                  text.indexOf('Mes dernières commandes') !== -1) {
                shouldRun = true;
                break;
              }
            }
          }
        }
      }
      
      // Also check for attribute changes (like when shadow DOM is attached)
      if (mutation.type === 'attributes') {
        shouldRun = true;
      }
    }
    
    if (shouldRun) {
      // Use requestAnimationFrame for better timing if available
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function() {
          hideFinancieresDiv();
          hideAddAddressButtonForAdmins();
          hideDataAnalysisForEmployees();
          // Also trigger retry mechanism
          setTimeout(function() {
            attemptHideSections(1, 5);
          }, 100);
        });
      } else {
        // Fallback for older browsers
        hideFinancieresDiv();
        hideAddAddressButtonForAdmins();
        hideDataAnalysisForEmployees();
        setTimeout(function() {
          attemptHideSections(1, 5);
        }, 100);
      }
    }
  });

  // Start observing with comprehensive options
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'id', 'open', 'hidden'] // Watch for relevant attribute changes
  });

  // Also observe document.documentElement for early content
  if (document.documentElement) {
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'id']
    });
  }

  // Listen for clicks on "Mon compte" / "My Account" button (ES5-compatible)
  document.addEventListener('click', function(event) {
    // Check for "Mon compte" or "My Account" button by title attribute
    var accountButton = event.target.closest('button[title="Mon compte"], button[title="My Account"]');
    if (accountButton) {
      // Hide Financières div immediately
      hideFinancieresDiv();
      // Hide "Ajouter une nouvelle adresse" button for Admins
      hideAddAddressButtonForAdmins();
      setTimeout(function() {
        attemptHideSections(1, 5);
      }, 200);
      setTimeout(function() {
        attemptHideSections(1, 3);
      }, 500);
      setTimeout(function() {
        attemptHideSections(1, 2);
      }, 1000);
      return;
    }

    // Also check for buttons containing "Mon compte" or "My Account" text
    var buttonWithAccountText = event.target.closest('button');
    if (buttonWithAccountText) {
      var buttonText = buttonWithAccountText.textContent || '';
      if (buttonText.indexOf('Mon compte') !== -1 || buttonText.indexOf('My Account') !== -1) {
        // Hide Financières div immediately
        hideFinancieresDiv();
        // Hide "Ajouter une nouvelle adresse" button for Admins
        hideAddAddressButtonForAdmins();
        setTimeout(function() {
          attemptHideSections(1, 5);
        }, 200);
        setTimeout(function() {
          attemptHideSections(1, 3);
        }, 500);
        setTimeout(function() {
          attemptHideSections(1, 2);
        }, 1000);
      return;
      }
    }

    // General SparkLayer interaction handler
    var sparkElement = event.target.closest('[class*="spark"], spark-drawer');
    if (sparkElement) {
      // Hide Financières div immediately
      hideFinancieresDiv();
      // Hide "Ajouter une nouvelle adresse" button for Admins
      hideAddAddressButtonForAdmins();
      // Run multiple checks with different delays for any SparkLayer interactions
      setTimeout(function() {
        continuousMonitoring();
        attemptHideSections(1, 5);
      }, 50);
      setTimeout(function() {
        continuousMonitoring();
        attemptHideSections(1, 5);
      }, 200);
      setTimeout(function() {
        continuousMonitoring();
        attemptHideSections(1, 5);
      }, 500);
      setTimeout(function() {
        continuousMonitoring();
        attemptHideSections(1, 5);
      }, 1000);
    }
  });

  // Also listen for focus events (when user interacts with account sections)
  window.addEventListener('focus', function() {
    setTimeout(function() {
      continuousMonitoring();
    }, 200);
  });

  // Listen for hashchange (SPA navigation)
  window.addEventListener('hashchange', function() {
    setTimeout(function() {
      continuousMonitoring();
      attemptHideSections(1, 10);
    }, 300);
  });

  // Listen for popstate (browser back/forward)
  window.addEventListener('popstate', function() {
    setTimeout(function() {
      continuousMonitoring();
      attemptHideSections(1, 10);
    }, 300);
  });

  // Listen for visibility change (when user switches tabs/windows)
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      // Page became visible, run checks
      setTimeout(function() {
        continuousMonitoring();
        attemptHideSections(1, 10);
      }, 200);
    }
  });

  // Additional check: verify hidden elements stay hidden
  var verificationInterval = setInterval(function() {
    // Check if any elements that should be hidden are visible
    var forceHiddenElements = document.querySelectorAll('.force-hidden-by-script');
    for (var i = 0; i < forceHiddenElements.length; i++) {
      var el = forceHiddenElements[i];
      if (!isElementHidden(el)) {
        hideElementReliably(el);
      }
    }
  }, 3000);

  // Keep observer running indefinitely - don't disconnect
  // The continuous monitoring interval handles periodic checks
  // Observer handles immediate changes
  
  // Additional observer specifically for shadow DOM content
  var shadowObserver = new MutationObserver(function(mutations) {
    var hasRelevantChanges = false;
    for (var m = 0; m < mutations.length; m++) {
      var mutation = mutations[m];
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        hasRelevantChanges = true;
        break;
      }
    }
    if (hasRelevantChanges) {
      // Small delay to allow shadow DOM to render
      setTimeout(function() {
        hideFinancieresDiv();
        hideAddAddressButtonForAdmins();
        hideDataAnalysisForEmployees();
      }, 150);
    }
  });

  // Watch for shadow DOM elements being added
  var shadowRootWatcher = setInterval(function() {
    var sparkDrawer = document.querySelector('spark-drawer');
    if (sparkDrawer && sparkDrawer.shadowRoot) {
      try {
        shadowObserver.observe(sparkDrawer.shadowRoot, {
          childList: true,
          subtree: true,
          attributes: true
        });
      } catch (e) {
        // Shadow root might not be accessible, ignore
      }
    }
    
    // Also check for other SparkLayer elements
    var sparkElements = document.querySelectorAll('[class*="spark"], [id*="spark"], spark-drawer');
    for (var i = 0; i < sparkElements.length; i++) {
      var element = sparkElements[i];
      if (element.shadowRoot) {
        try {
          shadowObserver.observe(element.shadowRoot, {
            childList: true,
            subtree: true,
            attributes: true
          });
        } catch (e) {
          // Shadow root might not be accessible, ignore
        }
      }
    }
  }, 1000);

  // Listen for SparkLayer ready event if available
  if (typeof window !== 'undefined') {
    window.addEventListener('sparklayer:ready', function() {
      setTimeout(function() {
        hideFinancieresDiv();
        hideAddAddressButtonForAdmins();
        hideDataAnalysisForEmployees();
        attemptHideSections(1, 10);
      }, 300);
    }, true);
    
    // Also listen for custom events that might indicate content is ready
    window.addEventListener('DOMContentLoaded', function() {
      setTimeout(function() {
        continuousMonitoring();
        attemptHideSections(1, 15);
      }, 500);
    });
  }

})();
